import { MenuItem, Paper, Tab, Tabs } from '@mui/material';
import { Box } from '@mui/system';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  CustomButton,
  SaveButton,
  SubmitButton,
} from '../../../components/common/button/CustomButtons';
import formatDate from '../../../components/common/formatDate';
import ChildHeader from '../../../components/ui/ChildHeader';
import { useQuery } from '../../../hooks/UseQuery';
import { useAuth } from '../../../services/auth/AuthProvider';
import TController from './create/TController';
import useGetData from '../helpers/useGetData';
import { getColumnLength } from '../helpers/utils';
import { GoSync } from 'react-icons/go';
import AutocompleteMuiCustom from '../../../components/common/AutocompleteMuiCustom';
import CustomSelect from '../../../components/common/SelectField';
import useConfirm from '../../../components/common/useConfirm';

interface MyData {
  moduleData: any;
  handelSync: any;
  DialogSync: any;
  setModuleData: any;
  customer: any;
  isLoading: boolean;
  error?: string | null;
  customerforAuto: any;
  setCustomerforAuto: any;
  prodArea: any;
  setProdArea: any;
}
const Create = () => {
  const { state } = useAuth();
  const navigate = useNavigate();
  const isView = useQuery('isView') === 'true' ? true : false;
  const annual_date = useQuery('annual_date');
  const created_date = useQuery('created_date');
  const [ChangeCustomer, confirmChangeCustomer] = useConfirm(
    'SAVE',
    'Save any changes before changing the Customer!'
  );
  const [ChangeProd, confirmChangeProd] = useConfirm(
    'SAVE',
    'Save any changes before changing The Filter!'
  );

  const {
    moduleData,
    isLoading,
    error,
    customer,
    handelSync,
    setModuleData,
    DialogSync,
    customerforAuto,
    setCustomerforAuto,
    prodArea,
    setProdArea,
  }: MyData = useGetData(annual_date, created_date);

  const onSubmit = async (isSubmitted: boolean) => {
    if (moduleData.length === 0) {
      alert('no data to save');
      return;
    }
    axios
      .post(`/api/salePlanningRoute`, moduleData)
      .then((res) => {
        window.alert('succesfully updated');
        // navigate(-1);
      })
      .catch((err) => console.log(err));
  };

  return (
    <Box>
      <Box>
        <ChildHeader text="RM INPUT Report">
          <Box
            sx={{
              backgroundColor: '#f8f9fa',
              borderRadius: '5px',
              mr: 2,
              width: '16.6vw',
            }}
          >
            <CustomSelect
              label="production area"
              name="production_area"
              value={prodArea || ''}
              onChange={async (e: any) => {
                const ans = await confirmChangeProd();
                if (!ans) return;
                setProdArea(e.target.value);
              }}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              <MenuItem value="Press Shop 1">Press Shop 1</MenuItem>
              <MenuItem value="Press Shop 2">Press Shop 2</MenuItem>
              <MenuItem value="Press Shop 3">Press Shop 3</MenuItem>
              <MenuItem value="Press Shop 4">Press Shop 4</MenuItem>
              <MenuItem value="Press Shop 5">Press Shop 5</MenuItem>
              <MenuItem value="Press Shop 6">Press Shop 6</MenuItem>
            </CustomSelect>
          </Box>
          <Box
            sx={{
              backgroundColor: '#f8f9fa',
              borderRadius: '5px',
              mr: 2,
              width: '16.6vw',
            }}
          >
            <AutocompleteMuiCustom
              label={''}
              id={'customer_name'}
              option_name={'customer_name'}
              value={customerforAuto}
              arrayofObj={customer}
              onChange={async (e, value) => {
                const ans = await confirmChangeCustomer();
                if (!ans) return;
                setCustomerforAuto(value);
              }}
            />
          </Box>
          {!isView && (
            <>
              <CustomButton
                sx={{
                  backgroundColor: '#228be6',
                  color: '#e7f5ff',
                  mr: 2,
                }}
                icon={<GoSync />}
                size="large"
                onClick={() => handelSync()}
              >
                Sync Parts
              </CustomButton>
              <SubmitButton label="Save" onClick={() => onSubmit(true)} />
            </>
          )}
        </ChildHeader>
      </Box>
      <TController
        {...{
          moduleData,
          isView,
          isLoading,
        }}
        numberOfDay={getColumnLength(annual_date || '')}
      />
      <DialogSync isSubmitContent={false} />
      <ChangeCustomer isSubmitContent={false} />
      <ChangeProd isSubmitContent={false} />
    </Box>
  );
};

export default Create;
